<template>
    <UCard>
      <template #header>
        <h3 class="text-sm font-semibold">{{ title }}</h3>
      </template>
      <div class="space-y-4">
        <USlider 
          :modelValue="modelValue"
          @update:modelValue="(val: [number, number] | undefined) => { $emit('update:modelValue', val as [number, number]) }"
          :min="minPrice" 
          :max="maxPrice"
          :step="step"
        />
        <div class="flex gap-2">
          <UInput 
            v-model="currentMinPrice"
            type="number" 
            placeholder="Min" 
            size="sm"
            @blur="validateMinPrice"
            :min="minPrice"
            :max="modelValue[1]"
            class="flex-1"
          />
          <UInput 
            v-model="currentMaxPrice"
            type="number" 
            placeholder="Max" 
            size="sm"
            @blur="validateMaxPrice"
            :min="modelValue[0]"
            :max="maxPrice"
            class="flex-1"
          />
        </div>
      </div>
    </UCard>
</template>
<script setup lang="ts">
const {
    minPrice = 0,
    maxPrice = 500,
    modelValue,
    step = 10,
    title = "Price Range"
} = defineProps<{
    modelValue: [number, number],
    minPrice?: number,
    maxPrice?: number,
    step?: number,
    title?: string
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', v: [number, number]): void
}>()


const currentMinPrice = ref(modelValue[0]);
const currentMaxPrice = ref(modelValue[1]);

watch(() => modelValue, (newVal) => {
    currentMinPrice.value = newVal[0];
    currentMaxPrice.value = newVal[1];
})

function validateMinPrice(event : Event) {
    let value =  Number((event.target as HTMLInputElement).value)

  if (value < minPrice) {
    value = minPrice
  }
  if (value > modelValue[1]) {
    value = minPrice
  }

  currentMinPrice.value = value;

  emit('update:modelValue', [value, modelValue[1]])
}

function validateMaxPrice(event : Event) {
    let value =  Number((event.target as HTMLInputElement).value)

  if (value > maxPrice) {
    value = maxPrice
  }
  if (value < modelValue[0]) {
    value = modelValue[1]
  }

  currentMaxPrice.value = value;

  emit('update:modelValue', [modelValue[0], value])
}

</script>